export function createRequestConfig(workspacesApiOptions) {
    var headers = {
        'x-ms-tenant-id': workspacesApiOptions.tenantId,
        'x-ms-user-id': workspacesApiOptions.userId,
        'x-ms-tenant-region': workspacesApiOptions.tenantRegionScope,
        'accept-language': workspacesApiOptions.acceptLanguage,
    };
    if (workspacesApiOptions.dataBoundary) {
        headers['x-ms-tdbr'] = workspacesApiOptions.dataBoundary;
    }
    return {
        headers: headers,
    };
}
//# sourceMappingURL=createRequestConfig.js.map